export const THANK_YOU_LIST_ITEM_TEXTS = {
  LINK_COPIED: "Link Copied!",
  DESKTOP_ONLY_EDIT: "Kindly use your desktop to edit this page",
  DUPLICATE_SUCCESS: "Duplicate page saved as draft",
  DELETE_SUCCESS: "Page deleted",
  TITLE_UPDATED: "Title updated",
  ERROR_GENERIC: "An error occured. Please try again after some time.",
  PUBLISHED: "Published",
  DRAFT: "Draft",
  DELETE_TITLE: "Delete Thank You Page",
  DELETE_BODY:
    "Are you sure you want to delete this thank you page? This action cannot be undone.",
  DELETE_BTN: "Delete",
  EDIT_TITLE: "Edit Title",
  EDIT_TITLE_LABEL: "Page title",
  SAVE_BTN: "Save",
  PREVIEW_FALLBACK: "Thank You Page Preview",
  UNTITLED: "Untitled",
};

export const THANK_YOU_LIST_ITEM_DIMENSIONS = {
  PREVIEW_IMAGE_HEIGHT: 66,
  PREVIEW_IMAGE_WIDTH: 132,
};

export const THANK_YOU_LIST_ITEM_DEBOUNCE_MS = 300;
